import { COLOR, MainNavigation, mixins, textStyles, zIndexValues } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  padding: 0 80px 40px;
`;

export const Illustration = styled.img`
  width: 1000px;
  user-select: none;
  pointer-events: none;
`;

export const Title = styled.div`
  ${textStyles.titleLarge700};
  color: ${COLOR.white};
  margin-top: -80px;
`;

export const Explanation = styled.div`
  ${textStyles.bodyLarge450};
  color: ${COLOR.white};
  text-align: center;
`;

interface GetStartedButtonProps {
  $isMainNavigationCollapsed: boolean;
}

export const GetStartedButton = styled.button<GetStartedButtonProps>`
  position: fixed;
  z-index: ${zIndexValues.getStartedButton};
  bottom: 20px;
  left: ${(props) =>
    20 +
    (props.$isMainNavigationCollapsed
      ? MainNavigation.CONTAINER_WIDTH_COLLAPSED
      : MainNavigation.CONTAINER_WIDTH_EXPANDED)}px;
  padding: 15px 12px;
  border-radius: 24px;
  background: ${COLOR.brand};

  display: flex;
  align-items: center;
  gap: 10px;

  ${textStyles.bodyMedium450};
  color: ${COLOR.white};

  ${mixins.clickable()};

  transition: left ${MainNavigation.CONTAINER_WIDTH_TRANSITION_TIME}ms
    cubic-bezier(0.83, 0, 0.17, 1);

  &:hover {
    background: ${mixins.rgba(COLOR.brand, 0.95)};
  }
`;
